import '../@claviska/jquery-minicolors/jquery.minicolors'
import '../@claviska/jquery-minicolors/jquery.minicolors.css'

$(".colorpicker").minicolors();